<ng-container *ngIf="!hotelSummeryFetched && csrStatus; else HotelTemplate">
  <div class="container lg:px-0 flex items-start gap-6">
    <div class="mobile-full-width relative">
      <iho-pdp-skeleton [isMobile]="navigatorVal" />
    </div>
  </div>
</ng-container>


<div class="container lg:px-0 flex items-start gap-6">
  <div class="w-full xl:max-w-[72%]">
    <iho-pdp-sticky-tabs *ngIf="(searchBoxService.mobileSearchBoxIsOpen | async) !== true && hotelSummeryFetched"
      (fragmentTabPending)="disableFragment()" [scrolledSection]="scrolledSection()"
      (selectTab)="goToSelectedTab($event)" class="sticky top-0 !z-20 block" [accommodation]="'ecolodge'" />

    <section id="baseData" #baseData>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-pdp-hotel-base-data [dataSource]="hotelInfoSummary?.HotelHeader" [type]="hotelInfoSummary?.Type"
          [isFavorite]="!!hotelInfoSummary?.IsFavourite" (goToMapEmit)="goToMap()" />
      </ng-container>
    </section>

    <section #host id="host-info" *ngIf="hotelInfoSummary?.HostInfo?.Name?.trim()">
      <iho-pdp-ecolodge-host *ngIf="hotelSummeryFetched" [dataSource]="hotelInfoSummary?.HostInfo" />
    </section>
    <section #generalinfo id="general-info">
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-pdp-ecolodge-general-info [dataSource]="hotelInfoSummary?.AccomodationSpecifications" />
      </ng-container>
    </section>
    <!-- <section #restrooms id="rest-rooms">
                  <ng-container *ngIf="hotelSummeryFetched">
                        <iho-pdp-ecolodge-restrooms />
                  </ng-container>
            </section> -->
    <section #facilities id="facilities" class="md:border-top">
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-pdp-ecolodge-facilities [dataSource]="hotelInfoSummary?.Facilities" [type]="hotelInfoSummary?.Type"
          [HotelInternetParking]="hotelInfoSummary?.HotelInternetParking"
          [travelHealth]="hotelInfoSummary?.TravelHealth" />
      </ng-container>
    </section>
    <section #calender id="calender">
      <div *ngIf="hotelSummeryFetched && isCalenderPriceFetched()">
        <ng-container *ngIf="isCalenderPriceFetched();else calenderLoading">
          <iho-pdp-ecolodge-calender-price (_isShow)="closeNopModal($event)" class="py-5"
            [showNopModal]="showNopModal()" [accommodationInfo]="hotelInfoSummary"
            (_resetEcolodgeInfoResults)="resetEcolodgeInfoResults()" />
        </ng-container>
        <ng-template #calenderLoading>
          <div class="mt-5">
            <iho-skeleton height="33px" width="200px" />
            <div class="grid grid-cols-3 gap-3 py-5">
              <iho-skeleton height="35px" width="100px" />
              <iho-skeleton height="35px" width="200px" />
            </div>
            <div class="flex justify-between gap-4">
              <iho-skeleton height="280px" width="400px" class="lg:block hidden" />
              <iho-skeleton height="280px" width="400px" class="lg:block hidden" />
              <iho-skeleton height="280px" width="100%" class="lg:hidden block w-full" />
            </div>
            <div class="flex items-center justify-end gap-2 mt-3 border border-top pt-3">
              <iho-skeleton height="35px" width="100px" />
              <iho-skeleton height="35px" width="100px" />
            </div>
          </div>

        </ng-template>
      </div>
    </section>
    <section id="rules" #rules>
      <ng-container *ngIf="hotelSummeryFetched">
          <iho-hotel-rules *ngIf="pdpUiService.hotelInfo().Type == 1" [dataSource]="hotelInfoSummary" />
          <iho-pdp-ecolodge-policies *ngIf="pdpUiService.hotelInfo().Type == 2" [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>
    <section id="map" #map>
      <ng-container *ngIf="csrStatus() && hotelSummeryFetched">
        <iho-pdp-ecolodge-map [isHotel]="hotelInfoSummary.HotelId ? true : false"
          [houseId]="hotelInfoSummary.HouseId ? hotelInfoSummary.HouseId : hotelInfoSummary.HotelId"
          [cityName]="hotelInfoSummary.HotelHeader.Address.CityName" [dataSource]="hotelInfoSummary?.HotelHeader"
          [accommodationType]="hotelInfoSummary.Type" />
      </ng-container>
    </section>
    <section id="distance" class="mt-4" #distance>
      <ng-container *ngIf="hotelSummeryFetched && hotelInfoSummary?.DistanceInfo">
        <iho-pdp-ecolodge-distances [dataSource]="hotelInfoSummary?.DistanceInfo" [type]="hotelInfoSummary?.Type"
          [nearBies]="hotelInfoSummary?.NearBies" />
      </ng-container>
    </section>



    <section id="about" class="mt-4" #about>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-about-hotel [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>


    <section id="comments" class="mt-4" #comments>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-comments [hotelId]="hotelInfoSummary?.HotelId" [dataVotes]="hotelInfoSummary?.Votes"
          [houseId]="hotelInfoSummary?.HouseId" [type]="hotelInfoSummary?.Type"
          [HotelHeader]="hotelInfoSummary?.HotelHeader"
          [dataSourceLabelHotelReview]="hotelInfoSummary?.LabelHotelReview" />
      </ng-container>
    </section>


    <ng-container *ngIf="(otherRooms$ | async)?.Hotels?.length">
      <section class="p-4 bg-metal-50 rounded-md flex flex-col items-stretch gap-4 mobile-full-width mt-4"
        id="similarHotelsSection" *ngIf="(otherRooms$ | async) as otherRooms">
        <div class="flex justify-between">
          <h2 class="text-xl font-bold">اتاق های دیگر این واحد اقامتی</h2>
          <a [href]="otherRooms?.CardHeaderPartial?.Link?.Url" class="float-left flex items-center">
            <span class="text-blue-500 text-sm !font-medium"> مشاهده همه</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
          </a>
        </div>

        <div class="!block md:!hidden w-full" *ngIf="otherRooms?.Hotels">
          <swiper [config]="config" id="swiperSimilarHotel">
            <ng-template swiperSlide *ngFor="let cardData of otherRooms?.Hotels">
              <iho-pdp-ecolodge-other-units [dataSource]="cardData" [type]="2" [hotelId]="hotelInfoSummary?.HotelId" />
            </ng-template>
          </swiper>
        </div>
        <div class="hidden md:grid md:grid-cols-4 items-center gap-4">
          <iho-pdp-ecolodge-other-units [type]="2" *ngFor="let item of otherRooms?.Hotels" [dataSource]="item" />
        </div>

      </section>
    </ng-container>

    <ng-container *ngIf="(similarHotels$ | async)?.Hotels?.length && csrStatus()">
      <section class="p-4 bg-metal-50 rounded-md flex flex-col items-stretch gap-4 mobile-full-width mt-4"
        id="similarHotelsSection" *ngIf="(similarHotels$ | async) as similarHotels" #similarHotelsSection>
        <div class="flex justify-between">
          <h2 class="text-xl font-bold">واحدهای اقامتی مشابه</h2>

        </div>
        <div class="!block md:!hidden w-full">
          <swiper [config]="config" id="swiperSimilarHotel">
            <ng-template swiperSlide *ngFor="let cardData of similarHotels?.Hotels;let index = index;">
              <ng-container *ngIf="index < 4">
                <iho-similar-hotels-card [dataSource]="cardData" [hotelId]="hotelInfoSummary?.HotelId" [type]="2" />
              </ng-container>
            </ng-template>
          </swiper>
        </div>

        <div class="hidden md:grid md:grid-cols-4 items-center gap-4">
          <ng-container *ngFor="let item of similarHotels?.Hotels;let index = index;">
            <ng-container *ngIf="index < 4">
              <iho-similar-hotels-card [dataSource]="item" [type]="2" />

            </ng-container>

          </ng-container>
        </div>
      </section>
    </ng-container>





    <section id="about" class="my-4" #faq>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-faq [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>

    <section id="links" class="my-4" #faq>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-relatedlinks [pdpLinks]="hotelInfoSummary?.NearStreets" [pdpPageGeneratorLinks]="hotelInfoSummary?.PageGeneratorLinks" />
      </ng-container>
    </section>

    <ng-container *ngIf="hotelSummeryFetched">
      <iho-pdp-breadcrumb class="md:hidden flex" [dataSource]="hotelInfoSummary?.BreadCrumb"
        [hotelName]="hotelInfoSummary?.Name" />
    </ng-container>

  </div>

  <!-- [class.sticky]="this.pdpUiService.selectedRooms().length < 4 -->
  <div class="w-[24rem] top-[10px] hidden lg:block z-40 sticky">
    <ng-container *ngIf="hotelSummeryFetched">
      <iho-pdp-sticky-sidebar (goToCalenderOutput)="handleAffixClick(true)" (searchNewEcolodgeCode)="newPdpSearch()"
        accommodation="ecolodge" />
    </ng-container>
  </div>

</div>


<ng-template #HotelTemplate>
  <section class="flex flex-col relative" *ngIf="hotelSummeryFetched && CalenderDetails">
    <div class="container lg:px-0 md:mb-4">

      <div class="w-full justify-between my-4 hidden md:flex">
        <!--
              [queryParams]="{search_box: hotelInfoSummary.HotelHeader.Address.CityName ,refer: 'hotelinfo', type: '1', 'city': cityId }"
              -->
        <iho-pdp-breadcrumb [hotelName]="hotelInfoSummary.Name" class="flex" [dataSource]="hotelInfoSummary.BreadCrumb"
          [cityName]=" hotelInfoSummary.HotelHeader.Address.CityName" />
        <a mat-button color="primary" [href]="hotelInfoSummary.BreadCrumb[1].Url + 'search/'"
          (click)="navToPlp(hotelInfoSummary.BreadCrumb[1].Url + 'search/',$event)"
          class="text-blue-500 !font-bold flex items-center">
          همه اقامتگاه بومگردی های {{
          hotelInfoSummary.HotelHeader.Address.CityName }}
        </a>
      </div>

      <div class="mobile-full-width relative">
        <div (click)="backToPlp()"
          class="bg-white rounded-full z-30 lg:hidden p-3 h-[32px] w-[32px] flex justify-center items-center absolute top-[10px] right-[22px]">
          <i class="ico-ArrowRight text-xl"></i>
        </div>

        <div (click)="addToFavorite()"
          class="bg-white rounded-full z-30 lg:hidden h-[32px] w-[32px] flex justify-center items-center absolute top-[10px] left-[22px]">
          <div class="typing-animation scale-[0.65]" *ngIf="loadingFavorite; else toggleFavorite">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <ng-template #toggleFavorite>
            <div ngClass="relative z-30"
              *ngIf="hotelInfoSummary.IsFavourite && this.authService.getUserData()();else noFavorite"
              class="filled-heart" style="width:22px"></div>
            <ng-template #noFavorite>
              <i class="ico-Heart text-xl relative z-30"></i>
            </ng-template>
          </ng-template>
        </div>
        <iho-pdp-gallery-wrapper [dataSource]="hotelInfoSummary?.ModalHotelGallery"
          [ecolodgeType]="hotelInfoSummary.Type" [hotelId]="hotelInfoSummary?.HotelId" />
      </div>
    </div>
  </section>
</ng-template>

<div class="lg:hidden fixed bottom-[64px] w-full bottom-affix-box-shadow !z-[21]">
  <iho-pdp-mobile-affix />
 
  <div *ngIf="hotelSummeryFetched && isCalenderPriceFetched()"
    class="w-full bg-white flex justify-between items-center !z-[55] p-2" id="init-section-room">
    <div class="pr-4">
      <p class="text-base text-gray-500 font-bold">
        {{'مبلغ نهایی پرداخت'
        }}
      </p>
      <p>
        <span class="text-black-500 text-2xl font-bold">
          {{ lowestSelectedRoomsPrice | toToman | number: '2.'
          }}
        </span>
        <span class="text-sm text-muted">تومان</span>
      </p>
    </div>
    <button (click)="handleAffixClick(false)" mat-flat-button color="primary" class="!h-11 w-[140px]">
      {{affixText()}}
    </button>
  </div>
</div>

<ng-container>
  <iho-bottom-nav-mobile [userData]="userData()" />
</ng-container>

<safarmarket-pixel />